<template>
  <div>
    <b-modal ref="my-modal" hide-footer title="Reenvío de mensaje de bienvenida">
      <div v-if="this.modalError === false" class="d-block text-center">
        <h3>¿Estás seguro(a) de que deseas reenviar el mensaje de bienvenida con la contraseña temporal al Conductor {{selDriver.firstName + ' ' + selDriver.lastName}}?</h3>
        <b-button class="mt-2" variant="outline-warning" block @click="resetPassDriver(selDriver, 'modal')" v-if="this.clicked === 0">Aceptar</b-button>
        <b-button class="mt-2" variant="outline-gray" block  v-else-if="this.clicked === 1">Enviando...</b-button>
        <b-button class="mt-2" variant="outline-success" block  v-else-if="this.clicked === 2">Mensaje enviado correctamente</b-button>
        <b-button class="mt-2" variant="outline-danger" block  v-else-if="this.clicked === 3">Ha ocurrido un error</b-button>
      </div>
      <div v-else-if="this.modalError === true" class="d-block text-center">
        <h3>El Conductor ya realizó el cambio de su contraseña temporal. En caso de requerir un cambio de contraseña indicar que realice el proceso correspondiente.</h3>
      </div>
    </b-modal>
    <b-modal ref="change-password" hide-footer title="Cambio de contraseña">
      <div class="d-block text-center">
        <p>¿Estás seguro(a) de que deseas cambiar la contraseña al Conductor <br> {{selDriver.firstName + ' ' + selDriver.lastName}}?</p>
        <div class="form-group text-left mb-4 mt-4 ml-3 mr-3" style="position: relative;">
          <label for="password" class="form-control-label">Nueva Contraseña</label>
          <input
            placeholder="Contraseña"
            id="password"
            class="input-lg form-control"
            :type="!passwordHidden ? 'password':'text'"
            v-model="getNewPassword.newPassword"
            autocomplete="off"
            trim
          />
          <span v-if="passwordHidden" class="display-eye fa fa-eye" @click="showPassword"></span>
          <span v-if="!passwordHidden" class="display-eye fa fa-eye-slash" @click="hidePassword"></span>
        </div>
        <div class="text-left mt-3 mb-4 ml-3 mr-3">
          <label for="confirm_password" class="form-control-label">Confirmar Contraseña</label>
          <input
            class="mb-2 input-lg form-control rounded-2"
            placeholder="Repetir Contraseña"
            id="confirm_password"
            type="password"
            v-model="getNewPassword.confirmPassword"
            autocomplete="off"
            trim
          />
        </div>
        <b-button class="mt-2" variant="outline-info" block @click="resetDriverPassword(selDriver, 'modal')" v-if="this.clicked === 0">Aceptar</b-button>
        <!-- b-button class="mt-2" variant="outline-gray" block  v-else-if="this.clicked === 1">Enviando...</!-->
        <!-- b-button class="mt-2" variant="outline-success" block  v-else-if="this.clicked === 2">Mensaje enviado correctamente</!-->
        <!-- b-button class="mt-2" variant="outline-danger" block  v-else-if="this.clicked === 3">Ha ocurrido un error</!-->
      </div>
    </b-modal>
    <b-row>
      <b-col md="6" lg="7">
        <h1 class="mb-3 mt-2"><b>Conductores</b></h1>
      </b-col>
      <b-col md="6" lg="5" class="text-right">
        <b-form-group label-cols-sm="12" class="mb-0 float-left">
          <b-input-group>
            <b-form-input v-model="filter" class="form-control" placeholder="Filtrar"></b-form-input>
            <b-input-group-append>
              <b-button :disabled="!filter" @click="filter = ''">Limpiar</b-button>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
        <b-form-group label-cols-sm="12" class="mb-0">
          <b-form-select v-model="perPage" :options="pageOptions" class="form-control"></b-form-select>
        </b-form-group>
      </b-col>
    </b-row>
    <b-table
      show-empty
      stacked="md"
      :items="getDrivers"
      :fields="fields"
      :current-page="currentPage"
      :per-page="perPage"
      :filter="filter"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      :sort-direction="sortDirection"
      @filtered="onFiltered"
      empty-text="No existen registros por mostrar"
      emptyFilteredText="No existen registros por mostrar"
    >
      <template v-slot:cell(acciones)="row">
        <b-dropdown id="dropdown-1" variant="btn-link border-0" class="float-right pb-0" dropleft no-caret>
          <template #button-content>
            <i class="fa-solid fa-ellipsis-vertical"></i>
          </template>
          <b-dropdown-group id="dropdown-group-1" header="Configuración">
            <b-dropdown-item @click="showResetPasswordModal(row.item)" title="Cambiar contraseña">
              <template>
                <i class="fa-solid fa-unlock"></i> Cambiar contraseña
              </template>
            </b-dropdown-item>
            <!-- b-dropdown-item @click="showModal(row.item)" title="Reenviar SMS">
              <template>
                <i class="fa-solid fa-comment-sms"></i> Reenviar SMS
              </template>
            </!-->
            <b-dropdown-item @click="createCheckoutOut(row.item)" title="Check Out">
              <template>
                <i class="fa-solid fa-right-from-bracket"></i> Checkout
              </template>
            </b-dropdown-item>
          </b-dropdown-group>
          <b-dropdown-divider></b-dropdown-divider>
          <b-dropdown-group id="dropdown-group-2" header="Estaus">
            <b-dropdown-item v-if="row.item.active === 0"  @click="showEnableDriverModal(row.item)">
              <template>
                <i class="fa-solid fa-unlock"></i> Habilitar
              </template>
            </b-dropdown-item>
            <b-dropdown-item>
              <router-link v-if="row.item.active === 1" size="sm" :to="{name:'disableDriver', params: row.item}" class="mr-1"><i class="fa-solid fa-ban"></i> Deshabilitar</router-link>
            </b-dropdown-item>
            <b-dropdown-item v-if="row.item.active === 0" @click="showDisabledEvidence(row.item)">
              <template>
                <i class="fa-solid fa-eye"></i> Visualizar evidencia
              </template>
            </b-dropdown-item>
          </b-dropdown-group>
        </b-dropdown>
        <!--<router-link size="sm" :to="{name:'postDrivers', params:{id:row.item.id}}" class="mr-1"><b-button class="btn-sm" variant="outline-warning">Editar</b-button></router-link>-->
        <!-- b-button class="btn-sm" variant="outline-warning"  @click="validateCheckIn(row.item)">Editar</! -->
        <!-- b-button style="margin-left: 5px" class="btn-sm" variant="outline-warning"  ></b-button>
        <b-button  style="margin-left: 5px" class="btn-sm" variant="outline-primary" >Habilitar</b-button>
        <b-button class="btn-sm" variant="outline-info" ><i class="fa-solid fa-comment-sms"></i></b-button>
        <b-button class="btn-sm" variant="outline-warning" ></b-button -->
        <!--<b-button style="margin-left: 5px" class="btn-sm" variant="outline-danger">Deshabilitar</b-button>-->
        <!--<b-button class="btn-sm" variant="outline-warning"  @click="$router.push({ name: 'updateDriver', params: row.item })">update</b-button>-->
      </template>
      <template v-slot:cell(active)="row">
        <b-badge pill class="p-0 pl-1" :class="row.item.active === 1 ? 'bg-success text-success' : 'bg-danger text-danger'">{{row.item.active === 1 ? 'a' : 'a'}}</b-badge>
      </template>
      <template v-slot:cell(firstName)="row">{{row.item.firstName}} {{row.item.lastName}}</template>
      <template v-slot:cell(phoneNumber)="row">
        <a href="#" @click="validateCheckIn(row.item)"><u>{{ row.item.phoneNumber }}</u></a>
        <!-- {{ row.item.phoneNumber.replace('+52','') }} -->
      </template>
    </b-table>
    <b-row>
      <b-col md="6" class="my-1">
        <b-pagination
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perPage"
          class="my-0"
        ></b-pagination>
      </b-col>
    </b-row>
    <div>
      <b-modal
        size="lg"
        ok-only
        id="modal-prevent-closing-motivos"
        ref="modal"
        title="Motivos de Baja"
        @hidden="hideModal"
      >
      <b-table
        show-empty
        stacked="md"
        :items="disabledDriver"
        :fields="fieldsMotivos"
        :per-page="1"
      >
        <template v-slot:cell(acciones)="row">
          <b-button class="btn-sm" v-if="!row.item.active" variant="outline-success" @click="viewEvidence(row.item.fileUrl)">Evidencia</b-button>
        </template>
      </b-table>
      </b-modal>
    </div>
    <div class="text-center" v-if="$apollo.queries.getDrivers.loading">
        <b-spinner variant="danger" label="Spinning">Cargando</b-spinner>
    </div>
  </div>
</template>

<script>
import gql from 'graphql-tag'
import headers from '@/config/headers.js'
import { Modal, notification } from 'ant-design-vue'
// import firebase from 'firebase'
const TAXI_CHECKIN_BY_DRIVERID_QUERY = gql`
  query getTaxiCheckInByDriverId($id: Int){
    getTaxiCheckInByDriverId(id: $id){
      id
      date
    }
  }
`
const TAXI_CREATE_CHECKOUT = gql`
  mutation createTaxiCheckOut($id: Int!) {
    createTaxiCheckOut(id: $id) {
      id
    }
  }
`
const DRIVER_STATUS = gql`
  query getDriverStatus($phoneNumber: String){
    getDriverStatus(phoneNumber: $phoneNumber){
      userStatus
    }
  }
`
// const RESET_DRIVER_PASSWORD = gql`
// mutation changeDriverPassword($phoneNumber: String){
// changeDriverPassword(phoneNumber : $phoneNumber){
// message
// }
// }
// `
const CHANGE_DRIVER_PASSWORD = gql`
  mutation changePassword($username: String, $password: String) {
    changePassword(username: $username, password: $password) {
      __typename
    }
  }
`
const ENABLE_DRIVER = gql`
mutation enableDriver($id: Int){
  enableDriver(id: $id){
    message
  }
}
`
const GET_DRIVER_DISABLED_EVIDENCE = gql`
 query getNewestBanByDriverId($driverId: Int) {
  getNewestBanByDriverId(driverId: $driverId) {
    id
    fileUrl
    disabledBy
    reason
    driver{
      id
      email
    }
  }
 }
`
const UPDATE_ENABLE_DRIVER = gql`
  mutation updateDriverEnable($driverId: Int $enabledBy: String ){
    updateDriverEnable(driverId: $driverId, enableDriver: { enabledBy: $enabledBy }){
      id
      enabledBy
    }
  }
`
const RESEND_PASSWORD_DRIVER = gql`
  mutation resendPasswordDriver($phoneNumber: String ){
    resendPasswordDriver(phoneNumber: $phoneNumber){
      success
    }
  }
`
export default {
  name: 'Franchises',
  data() {
    return {
      getNewPassword: {
        newPassword: null,
        confirmPassword: null,
      },
      getDrivers: [{}],
      getDriversConf: [{}],
      doed: false,
      fields: [
        { key: 'active', label: '' },
        { key: 'id', label: 'ID' },
        { key: 'phoneNumber', label: 'Teléfono' },
        { key: 'firstName', label: 'Nombre' },
        // { key: 'lastName', label: 'Apellidos' },
        { key: 'email', label: 'Correo electrónico' },
        { key: 'license', label: 'Licencia' },
        { key: 'cardId', label: 'Número de tarjetón' },
        // { key: 'motivos', label: 'Motivos de Baja' },
        { key: 'acciones', label: '' },
      ],
      fieldsMotivos: [
        { key: 'reason', label: 'Motivo', sortable: true, sortDirection: 'desc' },
        { key: 'driver.email', label: 'Conductor' },
        { key: 'disabledBy', label: 'Deshabilitado por:' },
        { key: 'acciones', label: 'Acciones' },
      ],
      autoRefresh: true,
      totalRows: 1,
      disabledDriver: null,
      currentPage: 1,
      perPage: 30,
      pageOptions: [10, 30, 50],
      sortBy: null,
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      id: 0,
      clicked: 0,
      selDriver: {},
      modalError: false,
      passwordHidden: true,
    }
  },
  apollo: {
    getDrivers: {
      query: gql`query getDrivers{
      getDrivers{
        id
        active
        cardExpiration
        cardId
        dateOfBirth
        firstName
        lastName
        license
        licenseExpiration
        phoneNumber
        profilePicture
        cognitoUsername
        email
        rfc
        driverAddress {
          id
          city
          extNumber
          intNumber
          postalCode
          state
          suburb
          street
        }
      },
     }`,
      context: headers(),
      error (erro) {
        console.log(erro)
      },
      result ({ data, loading, networkStatus }) {
        if (data.getDrivers != null && this.doed === false) {
          this.doed = true
          this.totalRows = data.getDrivers.length
          this.getDriversConf = data.getDrivers
          // this.getDriversConf.forEach(element => {
          //   this.getDriverStatus(element, 'query')
          //   if (element === this.getDriversConf[data.getDrivers.length - 1]) {
          //     console.log('finish')
          //     this.getDrivers = this.getDriversConf
          //   }
          // })
        }
      },
    },
  },
  methods: {
    hidePassword() {
      this.passwordHidden = true
    },
    showPassword() {
      this.passwordHidden = false
    },
    hideModal() {
      this.$refs.modal.hide()
    },
    viewEvidence(fileUrl) {
      window.open(fileUrl)
    },
    showModal(user) {
      console.log(user, 'user')
      this.getDriverStatus(user, 'modal')
      this.selDriver = user
      this.clicked = 0
    },
    showDisabledEvidence(driver) {
      this.$apollo.query({
        query: GET_DRIVER_DISABLED_EVIDENCE,
        variables: {
          driverId: parseInt(driver.id),
        },
        context: headers(),
      })
        .then(({ data }) => {
          // console.log(data)
          this.disabledDriver = [data.getNewestBanByDriverId]
          this.$refs.modal.show()
          /*
          if (data.getNewestBanByDriverId !== null) {
            Modal.confirm({
              title: `Motivo de baja del conductor ${driver.email}: ${data.getNewestBanByDriverId.reason}`,
              okText: 'Ver Evidencia',
              cancelText: 'Cancelar',
              onOk: () => {
                window.open(data.getNewestBanByDriverId.fileUrl)
              },
            })
          } */
        })
        .catch(error => {
          console.log(error)
        })
    },
    resetDriverPassword(driver) {
      console.log('driver ==> ', driver)
      console.log('getNewPassword ==> ', this.getNewPassword)
      if (this.getNewPassword.newPassword === this.getNewPassword.confirmPassword) {
        if (this.getNewPassword.newPassword.length < 8) {
          this.makeToast(true, 'danger', 'Error', 'La contraseña debe tener al menos 8 caracteres')
          return
        }
        this.$apollo.mutate({
          mutation: CHANGE_DRIVER_PASSWORD,
          variables: {
            password: this.getNewPassword.newPassword,
            username: driver.cognitoUsername,
          },
          context: headers(),
        })
          .then(data => {
            console.log(data)
            this.$refs['change-password'].hide()
            notification.success({
              message: '',
              description: 'Se restableció la contraseña del usuario ' + driver.email,
            })
            this.getNewPassword.newPassword = null
            this.getNewPassword.confirmPassword = null
          })
          .catch(err => {
            console.log(err)
            this.makeToast(true, 'danger', 'Error', 'Las contraseña no cumple con los parámetros establecidos')
          })
      } else {
        this.makeToast(true, 'danger', 'Error', 'Las contraseñas no coinciden')
      }
    },
    checkoutDriver(driver) {
      this.$apollo.query({ query: TAXI_CHECKIN_BY_DRIVERID_QUERY, context: headers(), variables: { id: parseInt(driver.id) } })
        .then(({ data }) => {
          if (data.getTaxiCheckInByDriverId === null) {
            this.showInactive(driver)
          } else {
            this.$apollo.mutate({
              mutation: TAXI_CREATE_CHECKOUT,
              variables: {
                id: driver.id,
              },
              context: headers(),
            })
              .then(data => {
                notification.success({
                  message: '',
                  description: `Se cerró la sesión del conductor ${driver.email}`,
                })
              })
              .catch(err => {
                console.log(err)
                this.makeToast(true, 'danger', 'Error', 'No se pudo cerrar la sesión del conductor. Intenta más tarde, si el problema persiste ponte en contacto con el administrador.')
              })
          }
        })
        .catch(error => {
          console.log(error)
          this.makeToast(true, 'danger', 'Error', 'Ocurrió un error. Intenta más tarde, si el problema persiste ponte en contacto con el administrador.')
        })
    },
    enableDriver(driver) {
      this.$apollo.mutate({
        mutation: ENABLE_DRIVER,
        variables: {
          id: parseInt(driver.id),
        },
        context: headers(),
      })
        .then(data => {
          /*
          firebase.firestore().collection('drivers').doc(String(driver.id)).get()
            .then(data => {
              console.log(data.exists)
              if (data.exists) {
                firebase.firestore().collection('drivers').doc(String(driver.id)).update({ driver: { ...driver, active: 1 } })
                  .then(data => {
                    console.log(data)
                  })
                  .catch(error => {
                    console.log(error)
                  })
              }
            })
            .catch(error => {
              console.log(error)
            })  */
          this.$apollo.mutate({
            mutation: UPDATE_ENABLE_DRIVER,
            context: headers(),
            variables: {
              driverId: parseInt(driver.id),
              enabledBy: this.$store.state.user.email,
            },
          })
            .then(data => {
              console.log(data)
            })
            .catch(error => {
              console.log(error)
            })
          this.$apollo.queries.getDrivers.refetch()
        })
        .catch(error => {
          console.log(error)
        })
    },
    resetPassDriver(driver) {
      this.clicked = 1
      this.$apollo.mutate({
        mutation: RESEND_PASSWORD_DRIVER,
        variables: {
          phoneNumber: driver.phoneNumber,
        },
        context: headers(),
      })
        .then(data => {
          this.clicked = 2
          console.log('sms sended')
        })
        .catch(error => {
          this.clicked = 3
          console.log(error)
        })
    },
    showEnableDriverModal(driver) {
      console.log(driver)
      Modal.confirm({
        title: `¿Estás seguro(a) que deseas habilitar al conductor ${driver.email}?`,
        okText: 'Aceptar',
        cancelText: 'Cancelar',
        onOk: () => {
          this.enableDriver(driver)
        },
      })
    },
    showResetPasswordModal(driver) {
      this.selDriver = driver
      this.getNewPassword.newPassword = null
      this.getNewPassword.confirmPassword = null
      this.$refs['change-password'].show()
    },
    createCheckoutOut(driver) {
      Modal.confirm({
        title: `Está acción realizará el checkout del conductor ${driver.email} y liberará el vehículo. ¿Deseas continuar?`,
        okText: 'Aceptar',
        cancelText: 'Cancelar',
        onOk: () => {
          this.checkoutDriver(driver)
        },
      })
    },
    validateCheckIn(driver) {
      this.$router.push({ name: 'updateDriver', params: driver })
    },
    getDriverStatus(driver, called) {
      // console.log(driver)
      this.$apollo.query({ query: DRIVER_STATUS, context: headers(), variables: { phoneNumber: driver.phoneNumber } })
        .then(({ data }) => {
          // console.log(data, 'conf')
          const driverinuse = (element) => element.phoneNumber === driver.phoneNumber
          console.log(called, 'cd')
          if (called === 'modal') {
            if (data.getDriverStatus !== null) {
              console.log(data.getDriverStatus.userStatus, 'ds')
              if (data.getDriverStatus.userStatus === 'FORCE_CHANGE_PASSWORD') {
                this.modalError = false
                this.$refs['my-modal'].show()
              } else {
                this.modalError = true
                this.$refs['my-modal'].show()
              }
            } else {
              this.modalError = true
              this.$refs['my-modal'].show()
            }
          } else {
            if (data.getDriverStatus !== null) {
              if (data.getDriverStatus.userStatus === 'FORCE_CHANGE_PASSWORD') {
                this.getDriversConf[this.getDriversConf.findIndex(driverinuse)].confirmed = false
              } else {
                this.getDriversConf[this.getDriversConf.findIndex(driverinuse)].confirmed = true
              }
            } else {
              this.getDriversConf[this.getDriversConf.findIndex(driverinuse)].confirmed = true
            }
          }
        })
        .catch(error => {
          console.log(error)
        })
    },
    showConfirm(driver) {
      Modal.info({
        title: 'En este momento no se puede editar la información de este conductor debido a que se encuentra activo. Por favor intente más tarde.',
        okText: 'Aceptar',
        cancelText: 'No',
        onOk() {},
      })
    },
    showInactive(driver) {
      Modal.info({
        title: 'El conductor no cuenta con sesión activa.',
        okText: 'Aceptar',
        cancelText: 'No',
        onOk() {},
      })
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    makeToast(append = false, variant, title, message) {
      this.$bvToast.toast(message, {
        title: title,
        autoHideDelay: 2000,
        appendToast: append,
        variant: variant,
      })
    },
  },
  created() {
    this.$apollo.queries.getDrivers.refetch()
  },
}
</script>
<style scoped>
</style>
